module.exports = __webpack_public_path__ + "media/images/bg-results-responsive-e0c7d94809a6b409cc5257f6be83ad72.jpg";